export enum ExternalJuniorHiringRoutesEnum {
  BASE = 'external-hiring/junior-plan',
  VALIDATE_IDENTITY = 'validate-identity',
  SUMMARY = 'summary',
  TRANSACTION_PASSWORD = 'transaction-password',
  SUCCESS = 'success',
  NEW_PASSWORD = 'new-password'
}
